import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import DefaultLayout from "../../../../layouts/DefaultLayout";
import { Link, Redirect, withRouter } from "react-router-dom";
import { Button, Card, Col, Descriptions, Row, Table, Typography } from "antd";
import { defaultCurrencyFormat } from "../../../../../utilities";

/**
 * Results component showing insurance info after user data has been sent to the server.
 */
@inject("context")
@withRouter
@observer
class Results extends Component {
	goToConfirmPage = (record) => {
		const { insuranceQuotingService } = this.props.context;
		insuranceQuotingService.setSelectedQuoteToProceed(record);
		if (insuranceQuotingService.clientData.quoteDefer === "false") {
			console.log(insuranceQuotingService.clientData.quoteDefer);
			this.props.history.push("/");
		} else {
			console.log(insuranceQuotingService.clientData.quoteDefer);
			this.props.history.push("/confirm");
		}
	};

	render() {
		const { insuranceQuotingService } = this.props.context;
		const { clientData, insuranceQuotes } = insuranceQuotingService;

		if (
			Object.entries(clientData).length === 0 &&
			Object.entries(insuranceQuotes).length === 0
		) {
			return <Redirect to="/" />;
		}

		const dataSource = insuranceQuotes.map((data, index) => {
			let shouldShowQuotations = "true";
			return {
				key: data.quoteId,
				quoteId: data.quoteId,
				insurerName: data.insurerName,
				pl_premium: data.pl_premium,
				el_premium: data.el_premium,
				equipment_premium: data.equipment_premium,
				gross_premium: data.gross_premium,
				admin_fee: data.admin_fee,
				ipt_amt: data.ipt_amt,
				total: data.total,
				startDate: data.startDate,
			};
		});

		dataSource.sort(function (x, y) {
			return x.total - y.total;
		});

		const columns = [
			{
				title: "Insurer",
				dataIndex: "insurerName",
			},
			{
				title: "PL Premium",
				dataIndex: "pl_premium",
				render: (text, record) => defaultCurrencyFormat(text),
			},
			{
				title: "EL Premium",
				dataIndex: "el_premium",
				render: (text, record) => defaultCurrencyFormat(text),
			},
			{
				title: "Equipment Premium",
				dataIndex: "equipment_premium",
				render: (text, record) => defaultCurrencyFormat(text),
			},
			{
				title: "Total Premium",
				dataIndex: "gross_premium",
				render: (text, record) => defaultCurrencyFormat(text),
			},
			{
				title: "Admin Fee",
				dataIndex: "admin_fee",
				render: (text, record) => defaultCurrencyFormat(text),
			},
			{
				title: "IPT",
				dataIndex: "ipt_amt",
				render: (text, record) => defaultCurrencyFormat(text),
			},
			{
				title: "Total",
				dataIndex: "total",
				render: (text, record) => defaultCurrencyFormat(text),
			},

			{
				title: "Action",
				key: "action",

				render: (text, record) => {
					return (
						<Button
							type="primary"
							disabled={text.quotation === "Referred to insurer"}
							onClick={() => this.goToConfirmPage(record)}
						>
							Proceed
						</Button>
					);
				},
			},
		];

		return (
			<DefaultLayout>
				<Row>
					<Col xs={24}>
						<Card title={<h1>Activity Insurance</h1>}>
							<Row>
								<Col xs={24}>
									<Descriptions
										title={
											<Typography.Title level={4}>
												Your details
											</Typography.Title>
										}
										bordered
										size="small"
										column={1}
									>
										<Descriptions.Item label="Name">
											{clientData.organisation.organisationFirstName}{" "}
											{clientData.organisation.organisationLastName}
										</Descriptions.Item>
										<Descriptions.Item label="Business Name">
											{clientData.organisation.organisationName}
										</Descriptions.Item>
										<Descriptions.Item label="Business Address">
											{[
												clientData.organisation.address.address1,
												clientData.organisation.address.address2,
												clientData.organisation.address.address3,
												clientData.organisation.address.address1,
												clientData.organisation.address.address5,
												clientData.organisation.address.city,
												clientData.organisation.address.post_code,
											]
												.filter((el) => el && el.trim())
												.join(", ")}
										</Descriptions.Item>
										<Descriptions.Item label="Turnover">
											£{clientData.pl_turnover}
										</Descriptions.Item>
										<Descriptions.Item label="Wageroll">
											£{clientData.el_wageroll}
										</Descriptions.Item>
										<Descriptions.Item label="Equipment Cover Level">
											£{clientData.equipment_cover_amt}
										</Descriptions.Item>
										<Descriptions.Item label="Primary Activity">
											{[clientData.activityTrades[0]]}
										</Descriptions.Item>
									</Descriptions>

									<Typography.Title style={{ margin: "2rem 0 0 0" }} level={4}>
										Your quote
									</Typography.Title>

									<Table
										dataSource={dataSource}
										columns={columns}
										pagination={false}
										style={{ margin: "2rem 0" }}
									/>

									<Row>
										<Col xs={24}>
											<Button>
												<Link to="/">{"<<"} Go Back</Link>
											</Button>
										</Col>
									</Row>
								</Col>
							</Row>
						</Card>
					</Col>
				</Row>
			</DefaultLayout>
		);
	}
}

export default Results;
